import { phoneCallUrl } from "@/lib/booking";
import { trackEvent } from "@/lib/analytics";

/** Quiet secondary link to the 15 minute phone call, shown under every fit call booking. */
export function PhoneCallLink({ placement, className = "" }: { placement: string; className?: string }) {
  return (
    <a
      href={phoneCallUrl(placement)}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      onClick={() => trackEvent("phone_call_click", { placement })}
    >
      Prefer a quick phone call? Book 15 minutes and Adam rings you.
    </a>
  );
}
